module.exports = __webpack_public_path__ + "static/media/alina-blaj.4c9b27d1.jpg";